import { render, staticRenderFns } from "./A7DashboardGeral.vue?vue&type=template&id=e1e0d738&scoped=true&"
import script from "./A7DashboardGeral.vue?vue&type=script&lang=js&"
export * from "./A7DashboardGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e0d738",
  null
  
)

export default component.exports